export default function getIntegrityPercent(found, found_count, found_modes) {
  if (found_count === -1) {
    return 0;
  }
  let percent1 = found_count !== 0 ? found / found_count : 0;
  let percent2 =
    found_modes && found_modes[0] !== 0 ? found / found_modes[0] : 0;
  return percent2 > 1 ? percent1 : Math.max(percent1, percent2);
}
